import { Link } from "gatsby"
import PropTypes from "prop-types"
import React from "react"
import styled from '@emotion/styled'

const HeaderStyled = styled.header`
  align-items: center;
  background-color: #fff;
  position: relative;
  width: 100%;
  /*border-bottom: 1px solid rgb(229, 227, 221);*/
  padding: 10px 1rem;
`

const Flex = styled.div`
  display: flex;
  align-items: center;
  flex:1;
  justify-content: space-between;
`

const End = styled.div`
  justify-self: end;
  font-size: .9rem;
  color: #222; 
  a {
    margin-left: 30px
  }
`

const Header = ({ siteTitle }) => (
  <HeaderStyled>

      <Flex>
      <h4 style={{ margin: 0 }}>
        <Link
          to="/"
          style={{
            color: `#444`,
            fontWeight:500,
            textDecoration: `none`,
            fontFamily:'Avenir Next',
            fontWeight: 600,
            fontSize: '1.1rem',
            letterSpacing: '-1px'
          }}
        >
         
        <svg height="45px" viewBox="0 0 180 159" version="1.1">
            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="Group-3" transform="translate(1.000000, 1.000000)">
                    <g id="Group-2" transform="translate(82.000000, 78.500000) rotate(-360.000000) translate(-82.000000, -78.500000) " stroke="#000000" stroke-width="5">
                        <rect id="Rectangle" transform="translate(73.500000, 83.500000) rotate(-345.000000) translate(-73.500000, -83.500000) " x="14" y="24" width="119" height="119" rx="5"></rect>
                        <rect id="Rectangle" fill="#FFFFFF" transform="translate(90.500000, 73.500000) rotate(-345.000000) translate(-90.500000, -73.500000) " x="31" y="14" width="119" height="119" rx="5"></rect>
                    </g>
                </g>
            </g>
        </svg>
        </Link>
      </h4>
      <End>
        <Link
          to="/ccpa"
          style={{
            color: `#222`,
            textDecoration: `none`,
          }}
        >
        What is the CCPA?
        </Link>

        <Link
          to="/about"
          style={{
            color: `#222`,
            textDecoration: `none`,
          }}
        >
        About
        </Link>
      </End>
      
      </Flex>
      

  </HeaderStyled>
)

export default Header
